import React, { useState } from 'react';
import { FiPlus, FiList } from 'react-icons/fi';
import AddCategory from './AddCategory';
import ListCategories from './ListCategories';

const Categories: React.FC = () => {
  const [activeView, setActiveView] = useState<'list' | 'add' | 'edit'>('list');
  const [categoryToEdit, setCategoryToEdit] = useState<number | null>(null);

  // Fonction pour passer à la vue d'édition
  const handleEditCategory = (categoryId: number) => {
    setCategoryToEdit(categoryId);
    setActiveView('edit');
  };

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-800">Gestione delle Categorie</h2>

        <div className="mt-4 flex gap-2">
          <button
            onClick={() => setActiveView('list')}
            className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2
              ${activeView === 'list' 
                ? 'bg-indigo-500 text-white' 
                : 'bg-white text-gray-600 hover:bg-gray-50'
              }`}
          >
            <FiList />
            Lista
          </button>
          <button
            onClick={() => setActiveView('add')}
            className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2
              ${activeView === 'add' 
                ? 'bg-indigo-500 text-white' 
                : 'bg-white text-gray-600 hover:bg-gray-50'
              }`}
          >
            <FiPlus />
            Aggiungere
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        {activeView === 'list' && <ListCategories onEditCategory={handleEditCategory} />}
        {activeView === 'add' && <AddCategory setActiveView={setActiveView} />}
        {activeView === 'edit' && categoryToEdit !== null && <AddCategory setActiveView={setActiveView} categoryId={categoryToEdit} />}
      </div>
    </div>
  );
};

export default Categories;
